import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getResidueCategoryList as getResidueCategoryListApi,
	getResidueCategory as getResidueCategoryApi,
	addNewResidueCategory as addNewResidueCategoryApi,
	updateResidueCategory as updateResidueCategoryApi,
	deleteResidueCategory as deleteResidueCategoryApi,
} from '../../helpers/residue/backend_helper';

export const getResidueCategoryList = createAsyncThunk('residueCategories/getResidueCategoryList', async () => {
	try {
		const response = getResidueCategoryListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getResidueCategory = createAsyncThunk('residueCategories/getResidueCategory', async residueCategory_id => {
	try {
		const response = getResidueCategoryApi(residueCategory_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewResidueCategory = createAsyncThunk('residueCategories/addNewResidueCategory', async residueCategory => {
	try {
		const response = addNewResidueCategoryApi(residueCategory);
		toast.success('ResidueCategory agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar residueCategory.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateResidueCategory = createAsyncThunk('residueCategories/updateResidueCategory', async (residueCategory) => {
		try {
			const response = updateResidueCategoryApi(residueCategory);
			toast.success('ResidueCategory actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar residueCategory.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteResidueCategory = createAsyncThunk('residueCategories/deleteResidueCategory', async residueCategory => {
	try {
		const response = await deleteResidueCategoryApi(residueCategory);
		toast.success('ResidueCategory eliminado exitosamente.', { autoClose: 3000 });
		return { residueCategory, ...response };
	} catch (error) {
		toast.error('Error al eliminar residueCategory.', { autoClose: 3000 });
		throw new Error(error);
	}
});
